import React, {forwardRef} from "react";
import styled from "styled-components";

import icoCheck from "../../assets/images/img_check.svg";
import icoCheckGray from "../../assets/images/img_check_gray.svg";


export const StdCheckboxWrap = styled.label`
    display: flex;
    align-items: center;
    column-gap: 8px;
    font: 400 15px "Pretendard";
    color: ${props => props.$disabled ? '#BBBBBB' : '#555555'};;
    //color: #555555;
`;

export const StdCheckbox = styled.input`
    appearance: none;
    width: 16px;
    height: 16px;
    border: 1px solid #e0e0e0;
    border-radius: 1px;
    cursor: ${(props) => (props.$disabled ? 'not-allowed' : 'pointer')};
    outline: none;
    background-color: ${(props) => (props.$disabled ? '#eeeeee' : 'transparent')};
    border-color: ${(props) => (props.$disabled ? '#bdbdbd' : '#e0e0e0')};

    margin-top: ${props => props.$marginTop ? props.$marginTop : 0};
    margin-bottom: ${props => props.$marginBottom ? props.$marginBottom : 0};
    margin-left: ${props => props.$marginLeft ? props.$marginLeft : 0};

    &:checked {
        border-color: transparent;
        background-size: 16px 16px;
        background-color: #036596;
        background-image: url(${icoCheck});
        background-position: center;
    }

    &:disabled {
        border-color: #bdbdbd;
        background-color: #eeeeee;
        cursor: not-allowed;

        &:checked {
            border-color: transparent;
            background-color: #9e9e9e;
            background-image: url(${icoCheckGray});
        }
    }

`;

const Checkbox = forwardRef(({ id, label, checked, onChange, isDisabled=false, marginTop=0, marginBottom=0, marginLeft=0, marginRight=0 }, ref) => {
    return (
        <StdCheckboxWrap htmlFor={id}
                         $disabled={isDisabled}> {/* 더 이상 margin 관련 prop을 전달하지 않습니다. */}

            <StdCheckbox
                type="checkbox"
                id={id}
                name={id}
                checked={checked}
                onChange={onChange}
                ref={ref}
                disabled={isDisabled}
                $marginTop={marginTop}
                $marginBottom={marginBottom}
                $marginLeft={marginLeft}
            ></StdCheckbox>
            <span style={{marginTop:marginTop, marginBottom:marginBottom, marginRight:marginRight}}>
                {label}
            </span>

        </StdCheckboxWrap>
    );
});

export default Checkbox;